import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Topic} from '../models/event';
import {Member} from '../models/member';
import {Ordered} from '../models/ordered';
import {Product} from '../models/product';
import {Subcategory} from '../models/subcategory';
import {HttpClient} from '@angular/common/http';

import {AuthService} from './auth.service';
import {MatDialog} from '@angular/material/dialog';


@Injectable({
  providedIn: 'root'
})
export class FrontDeskService {

  public dolarCotation: number;

  public currentMember: any;
  public currentProduct: any;
  public currentOrdered: any;
  public currentCategory: any;

  public memberOrders: any[] = []

  public updateMemberSituation: boolean = false;

  public spinner: boolean = false;
  public msgError: any = ""

  public nonMemberCategory: any = {}

  constructor (
    private db: AngularFirestore,
    private fb: FormBuilder,
    private ff: AngularFireFunctions,
    private _httpClient: HttpClient,
    public _authService: AuthService,
    private dialog: MatDialog
  ) { }

  /*
  getUserSubscription (doc): Observable<any> {
    this.spinner = true
    this.msgError = ''

    let url = 'https://us-central1-sbccv-proj.cloudfunctions.net/getUserSubscription';

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const body: any = {'doc': doc}
    return this._httpClient.post<any>(url, body, httpOptions)
      .pipe(
        retry(2),
        catchError((error) => {
          this.spinner = false
          console.log(error.status)
          this.msgError = "NÃO ENCONTRADO."
          return throwError(error.status);
        })
      )
  }
*/

  ////////////////////////////////////////////////////

  getMemberByCPF (cpf: string) {
    cpf = cpf.replace('.', '').replace('-', '')
    return this.db.collection<any>('sbccv_members', ref => ref
      .where('cpf', '==', cpf)
    ).get();
  }

  getOrdersByMemberId (member_id) {
    return this.db.collection<Member>('sbccv_orders', ref => ref
      .where('member_id', '==', member_id)
      .where('returnCode', '==', "00")
      .orderBy("product_name"))
      .get();
  }

  createMemberForm () {

    return this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      shortName: new FormControl('', [ Validators.required ]),
      email: new FormControl('', [ Validators.required, Validators.email ]),
      cellPhone: new FormControl('', [ Validators.required ]),
      cpf: new FormControl('', [ Validators.required ]),
      subCategory_id: new FormControl('', [ Validators.required ]),
      crm: new FormControl('')
    });

  }

  setMemberFormData (form: FormGroup, data: any) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.shortName.setValue(data.shortName);
    form.controls.email.setValue(data.email);
    form.controls.cellPhone.setValue(data.cellPhone);
    form.controls.cpf.setValue(data.cpf);
    form.controls.crm.setValue(data.crm);
    form.controls.subCategory_id.setValue(data.subCategory.id);
  }

  loadAllProducts () {
    return this.db.collection<Product>('sbccv_products', ref => ref
      .where('deleted', '==', false)
      .where('isAnnuity', '==', false)
      .where('active', '==', true)
      .where('available', '==', true)
      .where('available_purchase', '==', true)
      .orderBy('name', 'asc')).snapshotChanges()
  }



  load49Congress () {
    const id: string = "YJRjbDa32NTqSz3SpbzA" // *48º Congresso SBCCV • 2022 
    return this.db.doc<Product>('sbccv_products/' + id)
      .get();
  }

  checkRequirements (member_id: string, product_id: string) {

    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .where('member_id', "==", member_id)
      .where('product_id', "==", product_id)
      .where('returnCode', "==", "00")).get()

  }

  loadEventTopics (event_id) {
    return this.db.collection<Topic>('sbccv_event_topics', ref => ref
      .where('event_id', '==', event_id)
      .where('deleted', '==', false)).get()
  }

  loadEventTopicSlots (event_id) {
    return this.db.collection<Topic>('sbccv_event_slots', ref => ref
      .where('event_id', '==', event_id)).get()
  }

  selectSubcategoriesFrontDeskDb () {
    return this.db.collection<Subcategory>('sbccv_subcategories', ref => ref
      .where('front_desk', '==', true)
      //.where('sponsor', '==', false)
      .orderBy("name")).get();
  }

  selectSubcategoriesFrontDesk () {
    
    return [{
      "id": "m6BwcqDAZMyVKJZYCWqV",
      "name": "Acadêmico",
      "documents": "Cópia da declaração de matrícula da Instituição onde está matriculado.",
      "documents_en": "Copy of the registration statement of the Institution where you are enrolled.",
      "hidden": false,
      "partner": false
    }, {
      "id": "ukfcX7BgmsNCkpz0gnKL",
      "name": "LACES (Cirurgião)",
      "documents": "Comprovante ou declaração de sua Sociedade",
      "documents_en": "Proof or statement from your Society",
      "hidden": false,
      "partner": false
    }, {
      "id": "3pf0YhenFgEpoVzIvn8i",
      "name": "LACES (Residentes)",
      "documents": " Comprovante ou declaração de sua Sociedade  ",
      "documents_en": " Comprovante ou declaração de sua Sociedade  ",
      "hidden": false,
      "partner": false
    }, {
      "id": "H2AoWhktluQaWYuPydHC",
      "name": "Não Sócio",
      "documents": "",
      "documents_en": "",
      "hidden": false,
      "partner": false
    }, {
      "id": "ALUtUchCqgw72vtDLqfm",
      "name": "Residente/Especializando em Medicina",
      "documents": "Cópia da declaração da Instituição onde realiza a Residência Médica/Especialização.",
      "documents_en": "Copy of the declaration of the Institution where the Medical Residency/Specialization is carried out.",
      "hidden": false,
      "partner": false
    }, {
      "id": "6kopMqgiH31BYcUg5FIp",
      "name": "Sócio SBC",
      "documents": "",
      "documents_en": "",
      "hidden": false,
      "partner": false
    }]
  }

  loadAllMembers () {
    return this.db.collection<Member>('sbccv_members', ref =>
      ref.orderBy('name', 'asc')).snapshotChanges();
  }

  updateMember (member) {

    //  console.log("data: " + JSON.stringify(member))
    let id = member.id
     //delete member.id

    return this.db.collection('sbccv_members')
      .doc(id)
      .set(Object.assign({}, member), {merge: true});
  }

  /*

  registerPresence (body): Observable<any> {

    let url = 'https://us-central1-sbccv-proj.cloudfunctions.net/registerPresence';

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: '5AA6C5E4-28E7-4EF9-A608-733B760D703D'
      })

    };

    return this._httpClient.post<any>(url, body, httpOptions)
      .pipe(
        retry(2),
        catchError(this.registerPresence_handleError)
      )

  }

  registerPresence_handleError (error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {

      errorMessage = "client - " + error.error.message;
    } else {

      errorMessage = `server - Código do erro: ${ error.status }, ` + `menssagem: ${ error.message }`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  };

  */

  registerFrequency(data){
    return this.db.collection('sbccv_inout').add(Object.assign({}, data));
  }


  createOrder (payAsOverdue, balance, subscription, total, origin): Ordered {

    const user = this._authService.getLogged()
    const member = this.currentMember
    const product = this.currentProduct

    let order: Ordered = new Ordered()

    order.origin = origin

    order.member_id = member.id
    order.member_name = member.name
    order.member_email = member.email
    order.member_cellPhone = member.cellPhone
    order.member_cpf = member.cpf
    order.member_debit = balance

   // if(this.nonMemberCategory){
   //   order.category_id = this.nonMemberCategory.id
   //   order.category_name = this.nonMemberCategory.name
   // } else {
      order.category_id = member.subCategory.id
      order.category_name = member.subCategory.name
   // }

    order.date = new Date()

    order.value = subscription

    order.total = total

    order.payAsOverdue = payAsOverdue

    order.product_id = product.id
    order.product_name = product.name

    order.type = 'front-desk'
    order.payment_type = 'front-desk'
    order.returnCode = "front-desk"

    order.cash_operator = {
      'id': user.uid,
      'name': user.displayName
    }

    return order

  }

  insertOrder (entity: Ordered) {
    return this.db.collection('sbccv_orders').add(Object.assign({}, entity));
  }

  
  updateOrder (entity: Ordered) {
    return this.db.collection('sbccv_orders').doc(entity.id).update({'Tid': entity.Tid, 'returnCode': entity.returnCode});
  }

  printTicket(){
    //nonMemberCategory_id
  }
  
}
